export default "__VITE_ASSET__BiMSgSgr__"